import axios from '@/utils/axiosHelper';

// 获取角色列表
export const GetRoleList = (params) => {
  // return axios({ url: `/snail/query`, method: 'GET', params });
  return axios({ url: `/game/server`, method: 'GET', params });
};

// 绑定角色
export const BindRoleAPI = (data) => {
  return axios({ url: '/game/binds', method: 'POST', data });
};



// WEBPACK FOOTER //
// ./src/api/os.js